import Vue from 'vue'
import Router from 'vue-router'
const index = () => import('../pages/index.vue')
const common = () => import('../pages/ask/common.vue')
const commonDetail = () => import('../pages/ask/commonDetail.vue')
const pay = () => import('../pages/ask/pay.vue')
const onetoone = () => import('../pages/ask/onetoone.vue')
const onetooneDetail = () => import('../pages/ask/onetooneDetail.vue')
const telephone = () => import('../pages/ask/telephone.vue')
const news = () => import('../pages/ask/news.vue')
const capital = () => import('../pages/money/capital.vue')
const cashout = () => import('../pages/money/cashout.vue')
const verify = () => import('../pages/money/verify.vue')
const askset = () => import('../pages/set/askset.vue')
const account = () => import('../pages/set/account.vue')
const info = () => import('../pages/auth/info.vue')
const infoname = () => import('../pages/auth/infoname.vue')
const annual = () => import('../pages/auth/annual.vue')
const cases = () => import('../pages/auth/cases.vue')
const elaw = () => import('../pages/set/elaw.vue');
const paperwork = () => import('../pages/paperwork/list/index.vue');
const dialogue = () => import('../pages/paperwork/dialogue/index.vue');
const articleList = () => import('../pages/article/list/index.vue');
const articleOpen = () => import('../pages/article/open/index.vue');
const articleDetail = () => import('../pages/article/detail/index.vue');
const articlePublish = () => import('../pages/article/publish/index.vue');
const baike = () => import('../pages/article/baike/index.vue');
const baikeDetail = () => import('../pages/article/baike/baikeDetail.vue');

// 普通用户首页
const consumer = () => import('../pages/consumer/index/index.vue');
// 普通用户免费
const freeAsk = () => import('../pages/consumer/consult/free.vue');
// 普通用户电话
const telephoneAsk = () => import('../pages/consumer/consult/telephone.vue');
// 普通用户付费
const payAsk = () => import('../pages/consumer/consult/pay.vue');
// 普通用户一对一
const consultDetail = () => import('../pages/consumer/consult/detail.vue');

const onetooneAsk = () => import('../pages/consumer/consult/onetoone.vue');
const userInfo = () => import('../pages/consumer/set/info.vue');
const userAccount = () => import('../pages/consumer/set/account.vue');

const userDialogue = () => import('../pages/consumer/dialogue/index.vue');
const userpaperwork = () => import('../pages/consumer/paperwork/list/index.vue');
const userpaperdialogue = () => import('../pages/consumer/paperwork/dialogue/index.vue');


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/common',
      name: 'common',
      component: common,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/commonDetail',
      name: 'commonDetail',
      component: commonDetail,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/pay',
      name: 'pay',
      component: pay,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/onetoone',
      name: 'onetoone',
      component: onetoone,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/onetooneDetail',
      name: 'onetooneDetail',
      component: onetooneDetail,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/telephone',
      name: 'telephone',
      component: telephone,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/ask/news',
      name: 'news',
      component: news,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/money/capital',
      name: 'capital',
      component: capital,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/money/cashout',
      name: 'cashout',
      component: cashout,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/money/verify',
      name: 'verify',
      component: verify,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/set/askset',
      name: 'askset',
      component: askset,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/set/account',
      name: 'account',
      component: account,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/auth/info',
      name: 'info',
      component: info,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/auth/infoname',
      name: 'infoname',
      component: infoname,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/auth/annual',
      name: 'annual',
      component: annual,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/auth/cases',
      name: 'cases',
      component: cases,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/set/elaw',
      name: '',
      component: elaw,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/paperwork/list',
      name: '',
      component: paperwork,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/paperwork/dialogue',
      name: '',
      component: dialogue,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/list',
      name: '',
      component: articleList,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/open',
      name: '',
      component: articleOpen,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/baike',
      name: '',
      component: baike,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/baike/baikeDetail',
      name: 'baikeDetail',
      component: baikeDetail,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/detail',
      name: '',
      component: articleDetail,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/article/publish',
      name: '',
      component: articlePublish,
      meta: {
        needLogin: true,
        gid: 1
      }
    },
    {
      path: '/consumer',
      name: '',
      component: consumer,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/consult/free',
      name: '',
      component: freeAsk,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/consult/telephone',
      name: '',
      component: telephoneAsk,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/consult/pay',
      name: '',
      component: payAsk,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/consult/onetoone',
      name: '',
      component: onetooneAsk,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/user/info',
      name: '',
      component: userInfo,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/user/account',
      name: '',
      component: userAccount,
      meta: {
        needLogin: true,
        gid: 0
      }
    }, 
    {
      path: '/consult/detail',
      name: '',
      component: consultDetail,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/consult/dialogue',
      name: '',
      component: userDialogue,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/user/paperwork/list',
      name: '',
      component: userpaperwork,
      meta: {
        needLogin: true,
        gid: 0
      }
    },
    {
      path: '/user/paperwork/dialogue',
      name: '',
      component: userpaperdialogue,
      meta: {
        needLogin: true,
        gid: 0
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js